import {Accordion, AccordionTab} from "primereact/accordion";
import {Tag} from "primereact/tag";
import {DataTable} from "primereact/datatable";
import {Column, ColumnEditorOptions} from "primereact/column";
import {
    ParticipantType,
    routeParams,
    SeverityStatusParticipants,
    StatusPartipants
} from "../../types/types";
import React, {useState} from "react";
import {Button} from "primereact/button";
import {FaRegEdit} from "react-icons/fa";
import {Dialog} from "primereact/dialog";
import {InputNumber} from "primereact/inputnumber";
import {InputText} from "primereact/inputtext";
import {database, ref, remove, update} from "../../FirebaseService";
import {useParams} from "react-router-dom";
import {Dropdown} from "primereact/dropdown";
import {loadingStart, loadingStop} from "../../App";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import {Category} from "../../types/Category";

interface Props {
    categoryList: Category[],
    updateData: () => void
}

const initialCategory = new Category('', [], 0);

export default function AdminCategory({categoryList, updateData}: Props) {

    const {idEvent} = useParams<routeParams>();

    const [viewModalEdit, setViewModalEdit] = useState(false);

    const [categoryToEdit, setCategoryToEdit] = useState<Category>(initialCategory);

    const [categoryToEditId, setCategoryToEditId] = useState<number>(0);

    const modalEdit = {
        show: (category: Category, id: number) => {
            setCategoryToEditId(id)
            setCategoryToEdit(category);
            setViewModalEdit(true);
        },
        hide: () => setViewModalEdit(false),
    }

    const footerModalEditTemplate = () => <div>
        <Button size="small" label="Cancelar" text onClick={modalEdit.hide}/>
        <Button size="small" label="Salvar" autoFocus onClick={saveCategoryDate}/>
    </div>;

    const saveCategoryDate = async () => {

        await update(ref(database, `events/${idEvent}/categories/${categoryToEditId}`),
            {name: categoryToEdit.getName(), maxParticipants: categoryToEdit.getMaxParticipant()})
            .then(modalEdit.hide);

        updateData();
    }

    const headerCategory = (category: Category, categoryId: number) => {

        const name = category.getName();

        const participants = category.getParticipants();

        const counter: number[] = [];
        // const counter: { [status: string]: number } = {};

        Object.values(participants || {})
            .forEach((participant: ParticipantType) => {

                const status = parseInt(participant.status)

                if (counter[status]) {

                    counter[status]++;

                } else {

                    counter[status] = 1;
                }
            });

        return <div className="flex align-items-center gap-2 w-full">
            <span>{name}</span>
            {counter.map((value, i) => <Tag key={i} severity={SeverityStatusParticipants[i]}
                                            value={value}/>)}
            <Button rounded text severity="secondary" onClick={() => modalEdit.show(category, categoryId)}>
                <FaRegEdit size={24}/>
            </Button>
        </div>
    }

    const tagPlayerTemplate = (participant: ParticipantType) => {

        const status = parseInt(participant.status)

        return <Tag severity={SeverityStatusParticipants[status]}>{StatusPartipants[status]}</Tag>
    }

    const handleDeleteParticipants = async (player: ParticipantType, category: Category, categoryId: number) => {

        loadingStart();

        await remove(ref(database, `events/${idEvent}/categories/${categoryId}/participants/${player.idParticipants}`))
            .then(updateData);

    }
    const deletePlayerTemplate = (player: ParticipantType, category: Category, categoryId: number) => {

        const confirmDelete = () => {
            confirmDialog({
                message: () => <span>Você está certo que deseja excluir <b>{player.nomeSobrenome}</b>?</span>,
                header: "Cancelar Inscrição",
                icon: 'pi pi-exclamation-triangle',
                accept: () => handleDeleteParticipants(player, category, categoryId),
            });
        }

        return <Button icon="pi pi-trash" text severity="secondary" onClick={confirmDelete}/>
    }

    const inputSelectPaticipantEditor = (props: ColumnEditorOptions, field: string, categoryId: number, category: Category) => {

        const statusId = props.rowData[field];

        const options = StatusPartipants.map((status, i) => {
            return {
                label: status,
                id: i
            }
        })

        return (
            <Dropdown
                style={{fontSize: '10px'}}
                optionLabel="label"
                value={options.find(option => option.id === parseInt(statusId))}
                options={options}
                onChange={(e) => onEditorValueChange(props, e.target.value.id, categoryId, category)}
            />
        );
    };

    const onEditorValueChange = async (props: ColumnEditorOptions, newStatus: number, categoryId: number, category: Category) => {

        loadingStart();

        const player: ParticipantType = props.rowData;

        await update(ref(database, `events/${idEvent}/categories/${categoryId}/participants/${player.idParticipants}`), {status: newStatus})
            .then(loadingStop);

        updateData()
    };


    return <div style={{padding: 12}}>
        <h1>Categorias</h1>
        <Accordion>
            {categoryList.map((category, categoryId) => {

                const participants = category.getParticipants();

                const data = Object.values(participants || {})

                return <AccordionTab header={headerCategory(category, categoryId)} key={categoryId}>

                    <DataTable editMode="cell" stripedRows scrollable scrollHeight="300px" size="small"
                               value={data}>
                        <Column field="nomeSobrenome" header="Player" sortable/>
                        <Column field="status"
                                header="Status"
                                sortable
                                body={tagPlayerTemplate}
                                editor={(props) => inputSelectPaticipantEditor(props, 'status', categoryId, category)}
                        />
                        <Column body={(player) => deletePlayerTemplate(player, category, categoryId)}/>
                    </DataTable>

                </AccordionTab>
            })}
        </Accordion>

        <Dialog
            header="Editar Categoria"
            visible={viewModalEdit}
            onHide={modalEdit.hide}
            footer={footerModalEditTemplate}
        >

            <div className="modal-body flex flex-column gap-4">

                <div className="flex flex-column gap-2">
                    <label htmlFor="max_participants">Max. Participantes</label>
                    <InputNumber inputId="max_participants"
                                 value={categoryToEdit?.getMaxParticipant()}
                                 onChange={({value}) => categoryToEdit.setMaxParticipant(value ? value : 0)}
                                 max={50}/>
                </div>

                <div className="flex flex-column gap-2">
                    <label htmlFor="name">Nome</label>
                    <InputText id="name" value={categoryToEdit?.getName()}
                               onChange={({target}) => categoryToEdit.setName(target.value)}/>
                </div>
            </div>
        </Dialog>

        <ConfirmDialog/>

    </div>

}